import React, { Component } from "react";
import { Link } from "react-router-dom";
import { invokeApig } from '../../libs/awsLib';
import { Breadcrumb, PageHeader, Glyphicon, Table, ProgressBar } from "react-bootstrap";
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import FleetDatePicker from '../../components/FleetDatePicker';
import Joyride from 'react-joyride';

export default class TripDetail extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            startDate: props.startDate,
            endDate: props.endDate,
            data: [],
            runJoy: false,
            steps: [
              {
                target: '.react-bs-table-container',
                content: 'Puedes filtrar los vehículos.',
                placement: 'top',
              },
              {
                target: '.progress-bar',
                content: 'Por cada vehículo se muestra un puntaje de seguridad y ecología.',
                placement: 'bottom',
              }
            ]
        };
    }
    componentDidMount() {
    	this.updateManeuvers({});
    }
    async updateManeuvers() {
    	try {
        	const results = await invokeApig({
                path: "/trip/maneuvers",
                method: "POST",
                body: {
                	"units": this.state.units,
                    "startDate": this.state.startDate,
                    "endDate": this.state.endDate
                }
            });
        	this.setState({ data: results, isLoading: false });
        } catch (e) {
        	alert(e);
        	this.setState({ isLoading: false });
        }
    }
    onRowSelect = (row, isSelected, e) => {
    	alert(row);
    }
    setTableOption() {
    	if (this.state.isLoading) {
    	  return <div><Glyphicon glyph="refresh" className="spinning" />Cargando datos... por favor espere</div>;
	    } else {
	      return "No hay datos";
	    }
    }
    selectBarColor(value) {
    	if (value < 35) return 'danger';
    	if (value < 70) return 'warning';
    	return 'success';
    }
    scoreFormatter = (cell, row) => {
        return <ProgressBar now={cell} label={ cell + '%' } bsStyle={this.selectBarColor(cell)} />
    }
    render() {
    	const { steps, runJoy, data } = this.state;
        const selectRowProp = {
  		  mode: 'checkbox',
  		  bgColor: 'pink', // you should give a bgcolor, otherwise, you can't regonize which row has been selected
  		  hideSelectColumn: true,  // enable hide selection column.
  		  clickToSelect: true,  // you should enable clickToSelect, otherwise, you can't select column.
  		  onSelect: this.onRowSelect
  		};
    	const tableOptions = {
          noDataText: this.setTableOption()
        };
    	return (
	      <div className="Trip">
	        <Joyride
			    steps={steps}
			    run={runJoy}
				continuous={true}
				scrollToFirstStep={true}
				callback={this.callback}
				locale={{ back: 'Atrás', close: 'Cerrar', last: 'Finalizar', next: 'Siguiente', skip: 'Saltar' }}
			/>
		    <Breadcrumb>
			  <Breadcrumb.Item componentClass={Link} href="/" to="/">Home</Breadcrumb.Item>
			  <Breadcrumb.Item componentClass={Link} href="/trips" to="/trips">Viajes</Breadcrumb.Item>
		      <Breadcrumb.Item active>Maniobras</Breadcrumb.Item>
		      <Glyphicon className="help" glyph="info-sign" onClick={this.handleHelp} />
			</Breadcrumb>
		  	<PageHeader>
		      Viajes y maniobras
		    </PageHeader>
		    <Table responsive>
        	  <tbody>
        	    <tr>
        	  	  <td><FleetDatePicker onSelect={this.handleDatesSelec}/></td>
        	  	</tr>
        	  </tbody>
        	</Table>
        	<BootstrapTable data={ data } selectRow={ selectRowProp } options={tableOptions}>
                <TableHeaderColumn dataField='date' isKey>Fecha</TableHeaderColumn>
                <TableHeaderColumn dataField='module'>Maniobra</TableHeaderColumn>
                <TableHeaderColumn dataField='riskScore' dataFormat={ this.scoreFormatter }>Puntaje</TableHeaderColumn>
            </BootstrapTable>
		  </div>
	    );
    }
}


// WEBPACK FOOTER //
// ./src/containers/trip/TripDetail.js